import { useEffect } from "react";

interface ExternalRedirectProps {
  to?: string;
  /**
   * When true, forward the current location's pathname + search + hash
   * onto the target origin. Useful for legacy-site sweeps.
   */
  passthrough?: boolean;
  /** Origin to forward to when passthrough is enabled (no trailing slash). */
  origin?: string;
}

/**
 * Hard-redirects the browser to an external URL.
 * Uses window.location.replace so no history entry is created.
 */
const ExternalRedirect = ({ to, passthrough, origin }: ExternalRedirectProps) => {
  useEffect(() => {
    let target = to ?? "";
    if (passthrough && origin) {
      const { pathname, search, hash } = window.location;
      target = `${origin}${pathname}${search}${hash}`;
    }
    if (target) window.location.replace(target);
  }, [to, passthrough, origin]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <p className="text-muted-foreground">Redirecting…</p>
    </div>
  );
};

export default ExternalRedirect;